// extracted by mini-css-extract-plugin
module.exports = {"results":"style_results__2i8Dp","result":"style_result__2Ev0N"};